/** @format */
/* eslint-disable no-unused-vars */


import React, { useEffect, useState } from "react";
import { HomePage } from '../../styles/common.style';
import { Link, useNavigate } from 'react-router-dom';
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import BreadcrumbMenu from "./BreadcrumbMenu";
import CustomVideoPlayer from "./AssessmentTimer/CustomVideoPlayer";
const AboutNew = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Assessment Details', link: '#', isActive: true }
  ];

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, 100);
  }, []);
  
  return (
    <>
      {/* <Header /> */}
      <HomePage>
        <div className='about-main-learn-main'>
          <div className="about-main-learn-main-height-full">
            <section className='about-top about-top-second common-padding-about'>

              <div className='common-container'>
                <div className='row align-items-center'>
                  <div className='col-12 col-lg-8 col-md-8'>
                    <BreadcrumbMenu
                      breadcrumbs={breadcrumbs}
                      classNames={"breadcrumb-block"}
                    />
                  </div>
                </div>
                <div className='about-top-inner'>
                  <div className='about-top-inner-left'>
                    <h2 className='theme-color'>Artificial Intelligence Body Scan</h2>
                    <h3>Our Artificial Intelligence Body Scan :</h3>
                    <ul>
                      <li>Analyzes movement patterns </li>
                      <li>Detects imbalances, compensations, or dysfunctional movements. </li>
                    </ul>
                  </div>
                  <div className='about-top-inner-right'>
                    <img src='/images/about-new-page-3.png' alt='img' />
                  </div>
                </div>
              </div>
            </section>
            <section className='about-take-assign common-padding-about'>
              <div className='common-container'>
                <div className='about-take-assign-inner'>
                  <div className='about-take-assign-inner-block'>
                    <img src='/images/about-new-page-7.png' alt='img' />
                  </div>
                  <div className='about-take-assign-inner-block'>
                    <img src='/images/about-new-page-5.png' alt='img' />
                  </div>
                  <div className='about-take-assign-inner-block'>
                    <img src='/images/about-new-page-4.png' alt='img' />
                  </div>
                </div>
                <div className='about-new-btn'>
                  <button className='common-btn' onClick={() => navigate('/user-assessments')}>Take Our Assessment</button>
                </div>
              </div>
            </section>
          </div>
          <div className="about-main-learn-main-height-full diff-center-block">
            <section className='about-take-assign-second common-padding-about'>
              <div className='common-container'>
                <div className='about-take-assign-second-flex'>
                  <div className='about-take-assign-second-flex-inner'>
                    <img src='/images/tracking-image-left.jpg' alt='img' />
                    <p>
                      For example, during a single-leg squat, if your knee falls inward as you lower, it indicates that
                      your inner thigh and hip internal rotator muscles may be <span>overactive</span> while your glutes
                      and posterior hip muscles are <span className='text-blue'>underactive</span>.
                    </p>
                  </div>
                  <div className='about-take-assign-second-flex-inner'>
                    <img src='/images/tracking-image-right.jpg' alt='img' />
                    <p>
                      However, if your leg pulls outward as you lower, it suggests your inner thighs and hip Internal
                      rotator muscles are <span className='text-blue'>underactive</span> and your posterior hip muscles
                      are <span>overactive</span>.
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className='about-round-block common-padding-about'>
              <div className='common-container'>
                <div className='about-round-block-inner'>
                  <div className='about-round-block-inner-text'>
                    <p>Both movement dysfunctions can lead to knee, hip, or back pain...</p>
                  </div>
                  <div className='about-round-block-inner-text'>
                    <p>BUT the corrective exercises and stretches required for each are ENTIRELY DIFFERENT!</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <section className='determine-block'>
            <div className='determine-block-img'>
              <img src='/images/determine-img.png' alt='img' />
            </div>
            <div className='common-container'>
              <div className='determine-block-text text-center'>
                <h3>
                  Do you want to know which BODY TYPE <br></br>you have?
                </h3>
                <button className='common-btn' onClick={() => navigate('/login')}>Take Our Assessment</button>
              </div>
            </div>
          </section>
          <section className='body-type-block common-padding-about'>
            <div className='common-container'>
              <div className='common-title-block'>
                <h3>Body Types</h3>
              </div>
              <div className='body-type-block-inner'>
                <div className='body-type-block-inner-flex'>
                  <div className="body-type-block-inner-flex-content">
                    <h4>Anterior Pelvic Tilt</h4>
                    {/* <p>Pelvis tilts forward Excessive lumbar curve Hip flexor dominant</p> */}
                    <ul>
                      <li>Pelvis Tilts Forward</li>
                      <li>Lumbar Spine Excessively</li>
                      <li>Hip Folexor Dominant</li>
                    </ul>
                  </div>
                  {/* <div className='body-type-block-inner-flex-img'>
                    <img src='/images/body-img-about-2.png' alt='img' />
                  </div> */}
                </div>
                <div className='body-type-block-inner-flex'>
                  <div className="body-type-block-inner-flex-content">
                    <h4>Flat Back</h4>
                    <ul>
                      <li>Pelvis Tilts Back & Under</li>
                      <li>Lumbar Spine Flat</li>
                      <li>Hamstring Dominant</li>
                    </ul>
                  </div>
                  {/* <div className='body-type-block-inner-flex-img'>
                    <img src='/images/body-img-about-2.png' alt='img' />
                  </div> */}
                </div>
                <div className='body-type-block-inner-flex'>
                  <div className="body-type-block-inner-flex-content">
                    <h4>Sway Back</h4>
                    <ul>
                      <li>Hips Shift Forward / Tilt Back & Under</li>
                      <li>Knees Pressed Back</li>
                      <li>Upper Back Behind Midline</li>
                      <li>Hamstring Dominant</li>
                    </ul>
                  </div>
                  {/* <div className='body-type-block-inner-flex-img'>
                    <img src='/images/body-img-about-2.png' alt='img' />
                  </div> */}
                </div>
                <div className='body-type-block-inner-flex'>
                  <div className="body-type-block-inner-flex-content">
                    <h4>Bi-Funcational</h4>
                    <ul>
                      <li>One Side APT</li>
                      <li>Other Side PPT</li>
                    </ul>
                  </div>
                  {/* <div className='body-type-block-inner-flex-img'>
                    <img src='/images/body-img-about-2.png' alt='img' />
                  </div> */}
                </div>
              </div>
              <div className='body-type-img'>
                <img src='/images/body-img-about.png' alt='img' />
              </div>
            </div>
          </section>
          <section className='goal-block'>
            <div className='common-container'>
              <div className='common-title-block'>
                <h3>
                  Using BODY TYPES is a critical part of what we do
                </h3>
              </div>
              <div className='goal-block-img'>
                <div
                  className='goal-block-img'>
                  <CustomVideoPlayer
                    videoUrl="https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Body+Types+Explained+New+(NEW)+COM.mp4"
                    className={'video'}
                  />

                </div>
              </div>
            </div>
          </section>
        </div>
      </HomePage>
      <Footer />
    </>
  );
};

export default AboutNew;
